import { render, staticRenderFns } from "./free-proxy-list.vue?vue&type=template&id=456b67f2&scoped=true"
import script from "./free-proxy-list.vue?vue&type=script&lang=js"
export * from "./free-proxy-list.vue?vue&type=script&lang=js"
import style0 from "./free-proxy-list.vue?vue&type=style&index=0&id=456b67f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456b67f2",
  null
  
)

export default component.exports